import { render, staticRenderFns } from "./GetSpecificData.vue?vue&type=template&id=ca04ef02"
import script from "./GetSpecificData.vue?vue&type=script&lang=js"
export * from "./GetSpecificData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports